import JobManagement from './JobManagement';

export default JobManagement;
